import ImagePreloader from './ImagePreloader';

export default ImagePreloader;
